import { Card, Heading, Notification, Loader } from "@stellar/design-system";

import { ErrorWithExtras } from "@/components/ErrorWithExtras";
import { InfoTooltip } from "@/components/InfoTooltip";
import { LoadingContent } from "@/components/LoadingContent";
import { SectionHeader } from "@/components/SectionHeader";
import { WalletCard } from "@/components/WalletCard";

import { useWallets } from "@/apiQueries/useWallets";

import { ApiWallet } from "@/types";

export const WalletProviders = () => {
  const {
    data: wallets,
    error: walletsError,
    isPending: isWalletsPending,
    isFetching: isWalletsFetching,
  } = useWallets({});

  const myWallets = wallets?.filter((e) => e.enabled);
  const availableWallets = wallets?.filter((e) => !e.enabled);
  const isWalletsLoading = isWalletsFetching && !isWalletsPending;

  const renderWalletCard = (
    walletsArray: ApiWallet[] | undefined,
    cardType: "selected" | "available",
  ) => {
    if (walletsArray?.length) {
      return walletsArray?.map((item) => (
        <WalletCard
          key={item.id}
          walletName={item.name}
          homepageUrl={item.homepage}
          assets={item.assets?.map((asset) => asset.code)}
          userManaged={item.user_managed}
        />
      ));
    }

    return (
      <div className="Note">
        {cardType === "available"
          ? "There are no available wallet providers."
          : "There are no wallet providers allowed by your organization."}
      </div>
    );
  };

  return (
    <>
      <SectionHeader>
        <SectionHeader.Row>
          <SectionHeader.Content>
            <Heading as="h2" size="sm">
              Wallet Providers
            </Heading>

            {isWalletsLoading ? <Loader /> : null}
          </SectionHeader.Content>
        </SectionHeader.Row>
      </SectionHeader>

      {isWalletsPending ? <LoadingContent /> : null}

      <div className="CardStack">
        {walletsError ? (
          <Notification variant="error" title="Error" isFilled={true}>
            <ErrorWithExtras appError={walletsError} />
          </Notification>
        ) : null}

        {wallets ? (
          <>
            <Card>
              <div className="CardStack__card">
                <div className="CardStack__title">
                  <InfoTooltip infoText="The wallet providers allowed by your organization for receiving payments.">
                    Enabled Wallets
                  </InfoTooltip>
                </div>

                {renderWalletCard(myWallets, "selected")}
              </div>
            </Card>

            <Card>
              <div className="CardStack__card">
                <div className="CardStack__title">
                  <InfoTooltip infoText="All available wallet providers that can receive disbursements.">
                    Available Wallets
                  </InfoTooltip>
                </div>

                {renderWalletCard(availableWallets, "available")}
              </div>
            </Card>
          </>
        ) : null}
      </div>
    </>
  );
};
